import React from 'react'
import SelectedPropertyMetrics from './_selected_property_metrics';
import { Alert, Col, Row } from 'react-bootstrap';
import PaymentsPropertyDetails from './_payments_property_details';
import EtimsInvoiceGeenration from './_etims_invoice_generation';
import TenantInvoices from './_tenants_invoices';
import { useParams } from 'react-router-dom';
import { useGetPropertySettingsSummaryQuery } from '../../../lib/apiSlice/property/propertySlice.tsx';

export default function PropertySettingId() {
    const { id } = useParams<{ id: string }>(); // Type the id param

    // Pass the id as an argument to the query hook
    const { data, isLoading, isError, error } = useGetPropertySettingsSummaryQuery(id, {
        skip: !id,
    });

    const propertyMetrics = data?.data?.property_metrics;
    const tenantBreakdown = data?.data?.tenants_breakdown;
    const paymentDetails = data?.data?.payment_details;
    const invoices = data?.data?.invoices;

    const errorPayload = (error as { data?: { error?: string } | string } | undefined)?.data;
    const errorMessage =
        typeof errorPayload === 'string'
            ? errorPayload
            : errorPayload?.error || 'Failed to load property settings summary.';




    return (
        <>

            <div className="reports_dashboard">
                {isError && (
                    <Alert variant="danger" className="mt-4">
                        {errorMessage}
                    </Alert>
                )}

                <SelectedPropertyMetrics metrics={propertyMetrics} />
                  

                    <EtimsInvoiceGeenration />


                <Row>
                    <Col md={3} sm={6}>
                        <PaymentsPropertyDetails
                            tenantBreakDown={tenantBreakdown}
                            paymentDetails={paymentDetails}
                            isLoading={isLoading}
                        />

                    </Col>

                    <Col md={9} sm={6}>
                        <TenantInvoices invoices={invoices} isLoading={isLoading} />
                    </Col>
                </Row>

            </div>

        </>
    )
}
